var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'purchases-menu-wrapper',
  _vm.$arMediaQuery.pageContent.maxWidth('sm') && 'sm-max' ]},[_c('am2-heading',{staticClass:"section-heading",attrs:{"type":"h1","size":"md","title":"Purchases"}}),_vm._v(" "),_c('am2-search',{staticClass:"search-bar",style:({
        height: '50px',
      }),attrs:{"placeholder":"Search purchases","value":_vm.searchText},on:{"input":_vm.searchTextChange,"enter":_vm.serverSideSearch,"clear":_vm.serverSideSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }